import {api} from './api';

export const getEfficiencyApi = (plataforma: string | null, starttime: string, endtime: string) => {
    return api.get('reports/daily_reports/', {params:{plataforma, starttime, endtime}}).then(res => res.data)
}